import {useEffect, useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {TablesWidget9} from '../../../../_metronic/partials/widgets'
import {PatientCard} from './PatientCard'
import {getCoursePatientInfoByCourseId} from '../../../../Adaptor/TUBSIS'
import {CoursePatientInfo} from '../../../../Adaptor/TUBSIS/controllers/Courses/models/getCoursePatientInfoByCourseIdModels'
import {PatientStatus} from './PatientStatus'
import {Link} from 'react-router-dom'
import {REACT_APP_HANGFIRE} from '../../../../Adaptor/TUBSIS/endpoints'

const Patients = () => {
  const [userList, setUserList] = useState<CoursePatientInfo[] | null>(null)
  const [selectedUser, setSelectedUser] = useState<CoursePatientInfo | null>(null)
  // useEffect(() => {
  //   getCoursePatientInfoByCourseId(1)
  //     .then((response) => {
  //       ////debugger
  //       setUserList(response.data)
  //     })
  //     .catch((error) => {
  //       ////debugger
  //       console.log(error)
  //     })
  // }, [])

  useEffect(() => {
    getCoursePatientInfoByCourseId(1)
      .then((response1) => {
        getCoursePatientInfoByCourseId(2)
          .then((response2) => {

            const combinedData: CoursePatientInfo[] = [];

            if (response1 && response1.data) {
              combinedData.push(...response1.data);
            }
          
            if (response2 && response2.data) {
              combinedData.push(...response2.data);
            }
            
            setUserList(combinedData);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  
  // console.log(REACT_APP_HANGFIRE)
  return (
    <>
      {/* <a
        href={'https://tubsis.ege.edu.tr/api/hangfire'}//176.41.2.227:20081, https://localhost:5011, https://tubsis.ege.edu.tr/api/hangfire
        className='custom-list d-flex align-items-center px-5 py-4'
        //style={{visibility: 'hidden'}}
      >
        Mail Kontrol
      </a> */}
      <div className='d-flex flex-column flex-lg-row'>
        <div className='flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0'>
          <div className='card card-flush'>
            {/* <div className='card-header pt-7' id='kt_chat_contacts_header'>
              <form className='w-100 position-relative' autoComplete='off'>
                <KTIcon
                  iconName='magnifier'
                  className='fs-2 text-lg-1 text-gray-500 position-absolute top-50 ms-5 translate-middle-y'
                />

                <input
                  type='text'
                  className='form-control form-control-solid px-15'
                  name='search'
                  placeholder='Arama'
                />
              </form>
            </div> */}

            <div className='card-body pt-5' id='kt_chat_contacts_body'>
              <div
                className='scroll-y me-n5 pe-5 h-200px h-lg-auto'
                data-kt-scroll='true'
                data-kt-scroll-activate='{default: false, lg: true}'
                data-kt-scroll-max-height='auto'
                data-kt-scroll-dependencies='#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header'
                data-kt-scroll-wrappers='#kt_content, #kt_chat_contacts_body'
                data-kt-scroll-offset='0px'
              >
                {userList?.map((x) => (
                  <PatientCard
                    patient={x}
                    onClick={() => {
                      setSelectedUser(x)
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div>
          <PatientStatus patient={selectedUser} />
        </div>
      </div>
    </>
  )
}
export {Patients}
